<template>
  <div>
    <!-- Seccion confirmar -->
    <span
      class="tittlesDetails"
      v-if="permits['CONFIRM_NOTICE'] && notice.confirm == 'P'"
      >Autorizar o rechazar comunicado:</span
    >
    <!-- si el usuario tiene permisos de confirmar y el comunicado esta en pendiente  -->
    <v-list-tile v-if="permits['CONFIRM_NOTICE'] && notice.confirm == 'P'">
      <v-btn color="success" @click="authRejectNotice('autorizado')"
        >Autorizar</v-btn
      >
      <v-btn color="error" @click="authRejectNotice('rechazado')"
        >Rechazar</v-btn
      >
    </v-list-tile>

    <!-- Tittle -->
    <span class="tittlesDetails">Título:</span>
    <v-list-tile>
      <v-list-tile-title>{{ notice.title }}</v-list-tile-title>
    </v-list-tile>

    <!-- Type -->
    <span class="tittlesDetails">Tipo:</span>
    <v-list-tile>
      <v-list-tile-content>
        <span>{{ notice.type | noticeTypeFilter }}</span>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Status -->
    <span class="tittlesDetails">Estado:</span>
    <v-list-tile avatar>
      <v-list-tile-content>
        <span :class="getClassStatus()">{{
          notice.confirm | confirmFilter
        }}</span>
      </v-list-tile-content>
    </v-list-tile>

    <!-- Date -->
    <span class="tittlesDetails">Fecha de creación:</span>
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <img :src="require('@/assets/notices/SKLB-Evento.png')" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>{{
          notice.createdAt | dateFormat
        }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Date -->

    <!-- Publisher -->
    <span class="tittlesDetails">Creador:</span>
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <img
          v-if="notice.employee.img != null && notice.employee.img != ''"
          :src="'data:image/jpg;base64, ' + notice.employee.img"
        />
        <v-icon v-else color="gray lighten-4">person</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-if="notice.employee">{{
          notice.employee.firstName + ' ' + notice.employee.lastName
        }}</v-list-tile-title>
        <v-list-tile-title v-else>---</v-list-tile-title>
        <v-list-tile-sub-title v-if="notice.employee && notice.employee.rol">{{
          notice.employee.rol.name
        }}</v-list-tile-sub-title>
        <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Publisher -->

    <!-- Description -->
    <span v-if="showDescription && notice.description" class="tittlesDetails"
      >Descripción:</span
    >
    <v-layout
      row
      wrap
      justify-center
      v-if="showDescription && notice.description"
    >
      <v-flex xs11>
        <p
          class="description"
          v-for="(paragraph, key) in notice.description.split('\n')"
          :key="key"
        >
          {{ paragraph }}
        </p>
      </v-flex>
    </v-layout>
    <!-- Description -->

    <!-- Event summary -->
    <eventSumary
      :notice="notice"
      v-if="notice.type == 'E'"
      v-on:parent-confirm="showParentConfirm"
      v-on:parent-attendance="showParentAttendance"
      v-on:student-attendance="showStudentAttendance"
    ></eventSumary>
    <!-- Event summary -->

    <!-- Parent's reading tile -->
    <v-list-tile>
      <v-btn small color="primary" dark @click="showWatchedParents"
        >Ver confirmaciones de lectura</v-btn
      >
    </v-list-tile>
    <!-- Parent's reading tile -->

    <!-- Attachments -->
    <v-subheader v-if="notice.files && notice.files.length > 0"
      >Documentos anexados</v-subheader
    >
    <div v-if="notice.files && notice.files.length > 0" class="px-2">
      <v-btn
        class="ma-2 mb-3"
        rounded
        v-for="n in notice.files"
        :key="n.id"
        :href="n.fileUrl"
        target="_blank"
      >
        <v-icon left>save</v-icon>
        <strong>{{ n.name }}</strong
        >&nbsp; <span>{{ (n.size / (1024 * 1024)).toFixed(2) + 'Mb' }}</span
        >&nbsp;
      </v-btn>
    </div>
    <!-- Attachments -->

    <!-- Report :: parent authorizations -->
    <parentAuthorizations
      :notice="notice"
      v-if="notice.type == 'R'"
    ></parentAuthorizations>
    <!-- Report :: parent authorizations -->

    <v-divider></v-divider>
    <noticeAudience :notice="notice"></noticeAudience>

    <v-dialog v-model="alerts.autoriza" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ alerts.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="justify-center">
              <b>{{ alerts.descripcion }}</b>
            </v-layout>
            <v-spacer />
            <v-layout class="justify-center">
              <v-flex xs12 sm12>
                <v-textarea
                  outline
                  label="Razones"
                  placeholder="Breve descripción de por que autoriza o rechaza el comunicado"
                  v-model="motivosAuth"
                  rows="10"
                />
              </v-flex>
            </v-layout>
            <v-spacer />
            <v-layout class="justify-center">
              <!-- <v-btn color="primary darken-1" flat @click="alerts.elimina = false;" > Cancelar </v-btn>
              <v-btn flat @click="deleteNotice(); alerts.elimina = false; getNotices();"> Aceptar </v-btn> -->
              <v-btn
                color="primary darken-1"
                flat
                @click="
                  alerts.autoriza = false
                  motivosAuth = ''
                "
              >
                Cancelar
              </v-btn>
              <v-btn flat @click="applyDesition"> Aceptar </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import error from '../../Dialogs/Error'
import success from '../../Dialogs/Success'
import eventSumary from './EventSummary2'
import noticeAudience from './NoticeAudience2'
import parentAuthorizations from './ParentAuthorizations'

export default {
  components: {
    success,
    error,
    eventSumary,
    parentAuthorizations,
    noticeAudience,
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
      if (!this.permits['WATCH_NOTICE']) {
        this.toast.failed = true
      } else {
        return ''
      }
    }
  },
  props: ['notice', 'showDescription'],
  data: () => ({
    pendStatus: 'orangeText',
    nAuthStatus: 'yellowText',
    rechaStatus: 'redText',
    publicStatus: 'greenText',
    finaliStatus: 'grayText',
    saveStatus: 'grayText',
    permits: [],
    alerts: {
      title: 'AVISO',
      descripcion: '¿ Estas seguro que deseas eliminar este comunicado ?',
      autoriza: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    confirmNotice: false,
    deny: false,
    motivosAuth: '',
    // branch: {
    //       id: this.$store.getters.getBranch.id
    // },
  }),
  watch: {
    getUser() {
      this.mapPermits()
      if (!this.permits['WATCH_NOTICE']) {
        this.toast.failed = true
      } else {
        return ''
      }
    },
  },
  methods: {
    getClassStatus() {
      switch (this.notice.confirm) {
        case 'S':
          return 'saved'
        case 'A':
          return 'programming'
        case 'P':
          return 'to_authorized'
        case 'R':
          return 'refused'
        case 'I':
          return 'release'
        case 'F':
          return 'finish'
        case 'C':
          return 'cancelled'
      }
      return ''
    },
    showParentConfirm() {
      this.$emit('parent-confirm')
    },
    showParentAttendance() {
      this.$emit('parent-attendance')
    },
    showStudentAttendance() {
      this.$emit('student-attendance')
    },
    showWatchedParents() {
      this.$emit('parent-watched')
    },
    authRejectNotice(event) {
      // this.disabled = false;
      // this.$emit("loading");
      var target = event == 'autorizado' ? 'A' : 'R'

      if (target == 'A') {
        this.alerts.descripcion =
          '¿ Está seguro que desea autorizar este comunicado ?'
        this.alerts.autoriza = true
        this.confirmNotice = true
        this.deny = false
      } else {
        this.alerts.descripcion =
          '¿ Está seguro que desea rechazar este comunicado ?'
        this.alerts.autoriza = true
        this.confirmNotice = false
        this.deny = true
      }
    },
    applyAuthNotice() {
      this.$emit('loading')
      var target = ''

      if (this.deny) {
        target = 'R'
      } else if (this.confirmNotice) {
        target = 'A'
      }

      var body = {
        id: this.notice.id,
        // confirmDescription: this.motivosAuth,
        target: 'R',
      }
      console.log(
        'body____ id: ' +
          body.id +
          ' target: ' +
          body.target +
          ' motivos: ' +
          body.confirmDescription
      )
      this.$store
        .dispatch('notice/confirmNotice', body)
        .then((response) => {
          this.$emit('success')
          this.toast.success = true
          this.alerts.autoriza = false
        })
        .catch((error) => {
          this.$emit('failed')
          this.toast.failed = true
          this.alerts.autoriza = false
        })
      this.deny = false
      this.confirmNotice = false
    },
    applyDesition() {
      var target = ''
      if (this.deny) {
        target = 'R'
      } else if (this.confirmNotice) {
        target = 'A'
      }
      this.$store
        .dispatch('notice/authorizeNotice', {
          notice: this.notice,
          target: target,
          confirmDescription: this.motivosAuth,
        })
        .then((response) => {
          this.$emit('loading', false)
          this.$emit('success')
          this.toast.success = true
          this.alerts.autoriza = false
          this.motivosAuth = ''
          this.$emit('reload-auth', true)
        })
        .catch((error) => {
          this.$emit('loading', false)
          this.$emit('failed')
          this.toast.failed = true
        })
    },
    deleteModalNotice() {
      this.alerts.tittle = 'AVISO'
      this.alerts.descripcion =
        '¿ Estas seguro que deseas eliminar este comunicado ?'
      this.alerts.elimina = true
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('NOTICE')) {
          this.permits[catalogs[c].name] = 1
        }
      }
    },
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  filters: {
    dateFormat(value) {
      return moment(String(new Date(value))).format('DD/MM/YYYY')
    },
    noticeTypeFilter: function (type) {
      switch (type) {
        case 'A':
          return 'Aviso'
        case 'E':
          return 'Evento'
        case 'P':
          return 'Permiso'
        case 'R':
          return 'Aviso con confirmación'
      }
    },
    confirmFilter: function (confirm) {
      switch (confirm) {
        case 'S':
          return 'Guardado'
        case 'A':
          return 'Programado'
        case 'P':
          return 'Por autorizar'
        case 'R':
          return 'Rechazado'
        case 'I':
          return 'Publicado'
        case 'F':
          return 'Finalizado'
        default:
          return 'No autorizado'
      }
    },
  },
}
</script>

<style scoped>
.tittlesDetails {
  font-size: 1.4rem;
  font-weight: bold;
}

.v-list__tile {
  padding: 0% !important;
}
</style>
